import axios from 'axios'

export interface MetadataField {
  id: number,
  $ref: string,
  name: string,
  key: string,
  type: string,
  encrypted: boolean,
  exportable: boolean,
  readOnly: boolean,
  dataExplorerKey: string | null,
  acdDataTypeId: number,
  description: string | null,
  reconColumn: string | null,
}

export const getMetadataFields = (): Promise<MetadataField[] | MetadataField> => axios
  .get<MetadataField[] | MetadataField>('/api/rest/recording/metadatafields')
  .then(res => res.data)
